// extracted by mini-css-extract-plugin
export default {"resetButton":"K_520O9","root":"iu6M4zY","collapsedFactset":"d_jLFeQ"};